import Axios from "axios";
import customAxios from "./axios";
import * as types from "./types";
import CONFIG from "../../config";

export const userData = (data) => ({
  type: types.USER_DATA,
  data,
});

export const userAuthLogout = () => ({
  type: types.INIT_LOGOUT,
});

export const userLogin = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Auth/MobileLogin", payload).then(
    (response) => {
      return response;
    }
  );
};

export const getUser = (id) => {
  return customAxios.get(CONFIG.apiURL + `/Users/${id}`).then((response) => {
    return response;
  });
};

export const userLogout = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Auth/WebLogout", payload).then(
    (response) => {
      return response;
    }
  );
};

export const deleteAccount = (id) => {
  return customAxios
    .delete(CONFIG.apiURL + `/Users/AccountDelete?userId=${id}`)
    .then((response) => {
      return response;
    });
};
export const userChangePassword = (payload) => {
  return customAxios.post(CONFIG.apiURL + "/Users/changePassword", payload).then(
    (response) => {
      return response;
    }
  );
};

export const userRegister = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Users/Register", payload).then(
    (response) => {
      return response;
    }
  );
};

export const userUpdate = (payload) => {
  return customAxios.post(CONFIG.apiURL + "/User/ProfileUpdate", payload).then(
    (response) => {
      return response;
    }
  );
};

export const userForgotPassword = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Auth/ForgotPassword", payload).then(
    (response) => {
      return response;
    }
  );
};

export const sendOTP = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Auth/SendOtp", payload).then(
    (response) => {
      return response;
    }
  );
};

export const verifyOTP = (payload) => {
  return Axios.post(CONFIG.apiURL + "/Auth/VerifyOtp", payload).then(
    (response) => {
      return response;
    }
  );
};
